<div class="app-dialog">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text">
      <h2>{{ 'settings.billing.upfrontLicenseChange.title' | translate }}</h2>
      <p class="app-dialog__subtitle" *ngIf="data.subscriptionPeriod">
        {{ data.subscriptionPeriod === 'yearly' ? ('settings.billing.upfrontLicenseChange.yearlySubscription' | translate) : ('settings.billing.upfrontLicenseChange.monthlySubscription' | translate) }}
      </p>
    </div>
    <button mat-icon-button type="button" (click)="close()" [attr.aria-label]="'cancel' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body">
    <div class="form">
      <p class="subdomains-info" *ngIf="data.hasSubdomains">
        <mat-icon>info</mat-icon>
        {{ 'settings.billing.licensesCoverAllDomainsInfo' | translate }}
      </p>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'settings.billing.upfrontLicenseChange.licenseChange' | translate }}</mat-label>
        <input
          matInput
          type="number"
          [(ngModel)]="licenseChange"
        />
        <mat-hint *ngIf="licenseChange === 0 && !data.hasPeriodDifference">
          {{ 'settings.billing.upfrontLicenseChange.changeHint' | translate }}
        </mat-hint>
        <mat-hint *ngIf="isIncrease">
          {{ 'settings.billing.upfrontLicenseChange.increaseHint' | translate }}
        </mat-hint>
        <mat-hint *ngIf="isDecrease">
          {{ 'settings.billing.upfrontLicenseChange.decreaseHint' | translate }}
        </mat-hint>
      </mat-form-field>

      <div class="price-summary" *ngIf="isIncrease && proratedAmount > 0">
        <div class="price-row">
          <div class="price-row-content">
            <div class="price-row-header">
              <span class="price-label">{{ 'settings.billing.upfrontLicenseChange.proratedAmount' | translate }}:</span>
              <span class="price-value">{{ proratedAmountWithVat | number:'1.2-2' }} {{ data.currency }}</span>
            </div>
            <div class="approximate-note">{{ 'settings.billing.upfrontLicenseChange.approximatePriceNote' | translate }}</div>
          </div>
        </div>
        <div class="price-details">
          <div class="price-detail-row">
            <span>{{ 'settings.billing.upfrontLicenseChange.currentLicenses' | translate }}:</span>
            <span>{{ data.currentLicenseCount }}</span>
          </div>
          <div class="price-detail-row">
            <span>{{ 'settings.billing.upfrontLicenseChange.licenseChange' | translate }}:</span>
            <span>{{ formattedLicenseChange }}</span>
          </div>
          <div class="price-detail-row">
            <span>{{ 'settings.billing.upfrontLicenseChange.newLicenseCount' | translate }}:</span>
            <span>{{ newLicenseCount }}</span>
          </div>
          <div class="price-detail-row">
            <span>{{ 'settings.billing.price' | translate }}:</span>
            <span>{{ pricePerLicense }} {{ data.currency }}</span>
          </div>
          <div class="price-detail-row" *ngIf="hasVat">
            <span>VAT ({{ data.vatRate }}%):</span>
            <span>{{ proratedVatAmount | number:'1.2-2' }} {{ data.currency }}</span>
          </div>
        </div>
        <div class="disclaimer-inline" *ngIf="hasPriceDifference">
          {{ 'settings.billing.upfrontLicenseChange.stripePriceDiffers' | translate }}: {{ stripePriceRounded }} {{ data.stripeCurrency || data.currency }}
        </div>
      </div>

      <div class="price-summary" *ngIf="isDecrease">
        <div class="price-row">
          <div class="price-row-content">
            <div class="price-row-header">
              <span class="price-label" *ngIf="calculatedPrice > 0">{{ 'settings.billing.upfrontLicenseChange.newMonthlyAmount' | translate }}:</span>
              <span class="price-label" *ngIf="calculatedPrice === 0">{{ 'settings.billing.upfrontLicenseChange.decreaseInfo' | translate }}</span>
              <span class="price-value" *ngIf="calculatedPrice > 0">{{ calculatedPriceWithVat | number:'1.2-2' }} {{ data.currency }}</span>
            </div>
          </div>
        </div>
        <div class="price-details" *ngIf="licenseChange !== 0">
          <div class="price-detail-row">
            <span>{{ 'settings.billing.upfrontLicenseChange.currentLicenses' | translate }}:</span>
            <span>{{ data.currentLicenseCount }}</span>
          </div>
          <div class="price-detail-row">
            <span>{{ 'settings.billing.upfrontLicenseChange.licenseChange' | translate }}:</span>
            <span>{{ formattedLicenseChange }}</span>
          </div>
          <div class="price-detail-row">
            <span>{{ 'settings.billing.upfrontLicenseChange.newLicenseCount' | translate }}:</span>
            <span>{{ newLicenseCount }}</span>
          </div>
          <div class="price-detail-row">
            <span>{{ 'settings.billing.price' | translate }}:</span>
            <span>{{ pricePerLicense }} {{ data.currency }}</span>
          </div>
          <div class="price-detail-row" *ngIf="hasVat">
            <span>VAT ({{ data.vatRate }}%):</span>
            <span>{{ vatAmount | number:'1.2-2' }} {{ data.currency }}</span>
          </div>
        </div>
        <div class="disclaimer-inline" *ngIf="calculatedPrice === 0">
          {{ 'settings.billing.upfrontLicenseChange.decreaseNote' | translate }}
        </div>
        <div class="disclaimer-inline" *ngIf="hasPriceDifference">
          {{ 'settings.billing.upfrontLicenseChange.stripePriceDiffers' | translate }}: {{ stripePriceRounded }} {{ data.stripeCurrency || data.currency }}
        </div>
      </div>

      <div class="price-summary" *ngIf="licenseChange === 0 && !isIncrease && !isDecrease && (hasPriceDifference || data.hasPeriodDifference)">
        <div class="price-row" *ngIf="hasPriceDifference">
          <div class="price-row-content">
            <div class="price-row-header">
              <span class="price-label">{{ 'settings.billing.upfrontLicenseChange.stripePrice' | translate }}:</span>
              <span class="price-value">{{ calculatedPriceWithVat | number:'1.2-2' }} {{ data.currency }}</span>
            </div>
          </div>
        </div>
        <div class="price-details" *ngIf="hasPriceDifference">
          <div class="price-detail-row">
            <span>{{ 'settings.billing.upfrontLicenseChange.currentLicenses' | translate }}:</span>
            <span>{{ data.currentLicenseCount }}</span>
          </div>
          <div class="price-detail-row">
            <span>{{ 'settings.billing.price' | translate }}:</span>
            <span>{{ pricePerLicense }} {{ data.currency }}</span>
          </div>
          <div class="price-detail-row" *ngIf="hasVat">
            <span>VAT ({{ data.vatRate }}%):</span>
            <span>{{ vatAmount | number:'1.2-2' }} {{ data.currency }}</span>
          </div>
        </div>
        <div class="disclaimer-inline" *ngIf="hasPriceDifference">
          {{ 'settings.billing.upfrontLicenseChange.stripePriceDiffers' | translate }}
        </div>
      </div>

      <div class="period-change-notice" *ngIf="data.hasPeriodDifference">
        <mat-icon class="warning-icon">info</mat-icon>
        <div class="period-change-content">
          <div class="period-change-title">{{ 'settings.billing.upfrontLicenseChange.periodChangeTitle' | translate }}</div>
          <div class="period-change-details">
            <div class="period-change-item">
              <span>{{ 'settings.billing.upfrontLicenseChange.currentPeriod' | translate }}:</span>
              <span>{{ data.currentPeriod === 'yearly' ? ('settings.billing.yearly' | translate) : ('settings.billing.monthly' | translate) }}</span>
            </div>
            <div class="period-change-item">
              <span>{{ 'settings.billing.upfrontLicenseChange.newPeriod' | translate }}:</span>
              <span>{{ data.newPeriod === 'yearly' ? ('settings.billing.yearly' | translate) : ('settings.billing.monthly' | translate) }}</span>
            </div>
            <div class="period-change-item" *ngIf="data.nextBillingCycleDate">
              <span>{{ 'settings.billing.upfrontLicenseChange.effectiveDate' | translate }}:</span>
              <span>{{ data.nextBillingCycleDate | date: 'dd.MM.yyyy' }}</span>
            </div>
          </div>
          <div class="period-change-message">
            {{ 'settings.billing.upfrontLicenseChange.periodChangeMessage' | translate }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <footer class="app-dialog__footer">
    <button mat-stroked-button type="button" (click)="close()">{{ 'cancel' | translate }}</button>
    <button
      mat-raised-button
      color="primary"
      type="button"
      (click)="submit()"
      [disabled]="sendingRequest || !canSubmit"
    >
      {{ sendingRequest ? ('saving' | translate) : ('settings.billing.upfrontLicenseChange.proceed' | translate) }}
    </button>
  </footer>
</div>
